import { Grid, useMediaQuery, useTheme } from "@material-ui/core";
import { Block, Save } from "@material-ui/icons";
import Config, {
  PERMISSION_ROLE_HIS_PAYMENT,
  PROMOTION_CODES,
  REQUIRED_CTKM,
  REQUIRED_CTKM_DISCOUNT,
} from "app/appConfig";
import CommonButton from "app/common/Component/Button/CommonButton";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import PopupForm from "app/common/Component/Popup/PopupForm";
import GlobitsAutocomplete from "app/common/form/GlobitsAutocomplete";
import GlobitsAutocompleteTextAndSelect from "app/common/form/GlobitsAutocompleteTextAndSelect";
import GlobitsCheckBox from "app/common/form/GlobitsCheckBox";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import GlobitsNumberInput from "app/common/form/GlobitsNumberInput";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsSelectInput from "app/common/form/GlobitsSelectInput";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import GlobitsVNDCurrencyInput from "app/common/form/GlobitsVNDCurrencyInput";
import GlobitsVNDCurrencyInputOnlyChange from "app/common/form/GlobitsVNDCurrencyInputOnlyChange";
import useDefaultDepartment from "app/common/hooks/useDefaultDepartment";
import IconDelete from "app/common/Icon/IconDelete";
import {
  CARD_PATIENT_STATUS,
  INVOICE_PAID,
  INVOICE_PARTIAL_PAID,
  LEAD_SOURCE_LEVEL,
  PathModule,
  POPUP_TYPE_CARD,
  TYPE_CARD,
} from "app/common/LocalConst";
import {
  formatMoney,
  getPriceTypeService,
  getPromotionCodes,
  handleGetQRCodeByValue,
  isRoleHisPayment,
  validateEqualsSourceDiffirentTelesale,
  validateMaxTotalAmountTelesale,
  validateMaxTotalDiffTelesale,
  validateSelectDiffirentTelesale,
  validateSelectTelesale,
} from "app/common/LocalFunction";
import DeductionList from "app/PatientManagement/DeductionList/DeductionList";
import SourceRegister from "app/PatientManagement/PatientGeneral/PatientGeneralTabs/Component/SourceRegister";
import { pagingClientCard } from "app/services/ClientCardService";
import { getListCode } from "app/services/CustomerSourceService";
import { pagingPatient } from "app/services/PatientService";
import { pagingProgram } from "app/services/PromotionCRMService";
import { useStore } from "app/stores";
import { FieldArray, getIn, useFormikContext } from "formik";
import { observer } from "mobx-react";
import { forwardRef, memo, useEffect, useState } from "react";
import { filterBaseOptions } from "utils";
import * as Yup from "yup";
import RowTotalCard from "../../RegisterProductTab/Component/RowTotalCard";
import RegisterServiceStaffsRevenue from "../../RegisterServiceTreatmentPlanTab/Popup/RegisterServiceStaffsRevenue";
const RegisterCardPopup = ({
  open,
  handleClose,
  onSubmit,
  initRegisterCard,
  listVatPercent,
  patient,
  customerSourceWalkIn,
  handleAfterSubmit,
  defaultFreePromotion,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const { handleGetListVatPercent, initialPatient } =
    useStore().patientManagementStore.patientGeneralStore;
  const { listCodeSource } =
    useStore().patientManagementStore.registerCardStore;
  const department = useDefaultDepartment();
  const handleGetListCodeSource = async (obj, setFieldValue) => {
    try {
      const { data } = await getListCode(obj);
      setFieldValue("listCodeSource", data || []);
    } catch (error) {
      //console.error(error);
    }
  };
  useEffect(() => {
    handleGetListVatPercent();
  }, []);

  const validationSchema = Yup.object().shape({
    department: Yup.object().nullable().required("Chưa cơ sở!"),
    percentDiscount: Yup.number()
      .min(0, "Giảm giá phải lớn hơn 0!")
      .max(100, "Giảm giá không vượt quá  100!")
      .test(
        "validate-percentDiscount",
        "Không được quá % giảm giá của chương trình khuyến mãi này",
        function (value) {
          const { promotionProgram } = this.parent;
          if (!PROMOTION_CODES?.includes(promotionProgram?.code)) return true;

          if (
            promotionProgram &&
            promotionProgram?.allProductMaxDiscountPercent != null
          ) {
            if (value > promotionProgram?.allProductMaxDiscountPercent)
              return false;
          }
          if (promotionProgram && promotionProgram?.products?.length > 0) {
            if (value > promotionProgram?.products[0]?.maxDiscountPercent)
              return false;
          }
          return true;
        }
      )
      .nullable(),
    discount: Yup.number()
      .nullable()
      .test(
        "less-than-or-equals-to-totalAmount",
        "Tiền giảm giá không được lớn hơn tổng tiền",
        function (discount) {
          const { totalAmount } = this.parent;
          if (discount > totalAmount) return false;
          return true;
        }
      ),
    price: Yup.number()
      .min(0, "Giá phải lớn hơn hoặc bằng 0!")
      .nullable()
      .required("Chưa nhập giá!"),

    totalAmount: Yup.number()
      .typeError("Thành tiền phải là số")

      .test(
        "validate-amount",
        "Không được bán dưới mức giá tối thiểu",
        function (value) {
          const { clientCard } = this.parent;
          if (!clientCard?.minSellingPrice || !value) {
            return true;
          } else {
            if (value < clientCard?.minSellingPrice) {
              return false;
            }
            return true;
          }
        }
      )
      .nullable(),

    staffRevenues: Yup.array()
      .min(1, "Cần thêm ít nhất 1 phân bổ!")
      .of(
        Yup.object()
          .shape({
            position: Yup.object()
              .nullable()
              .required("Bắt buộc nhập chức danh"),
            staff: Yup.object().nullable(),
            source: Yup.object()
              .nullable()
              .required("Bắt buộc nhập nguồn phân bổ")
              .test(
                "source-in-list",
                "Nguồn phân bổ không hợp lệ",
                function (value) {
                  const listCodeSource =
                    this.options.context?.listCodeSource || [];
                  // Nếu chưa chọn hoặc thiếu code → invalid
                  if (!value || !value.code) return false;
                  // Không có danh sách thì cho pass
                  if (listCodeSource.length === 0) return true;

                  const first = listCodeSource[0];

                  // Mảng string: ["CTV", "KR", ...]
                  if (typeof first === "string") {
                    return listCodeSource.includes(value.code);
                  }

                  // Mảng object: [{code: "CTV"}]
                  if (typeof first === "object" && first !== null) {
                    return listCodeSource.some(
                      (item) => item.code === value.code
                    );
                  }

                  return false;
                }
              ),
            actualAmount: Yup.mixed()
              .nullable()
              .test("greater-than-zero", "Giá trị phải lớn hơn 0!", (value) => {
                if (value === null || value === "") return true;
                return typeof value === "number" && value >= 0;
              }),
            percentRevenue: Yup.mixed()
              .nullable()
              .test(
                "max-100",
                "Phân bổ doanh thu phải nhỏ hơn hoặc bằng 100!",
                (value) => {
                  if (value === null || value === "") return true;
                  return typeof value === "number" && value <= 100;
                }
              ),
          })
          .test(
            "at-least-one-selected",
            "Phải chọn Nhân viên!",
            function (value) {
              if (!value) return false;
              const { staff } = value;
              return !!staff;
            }
          )
      )
      .test(
        "at-least-one-diffirent-sale",
        "Cần chọn phân bổ cho người tư vấn !",
        validateSelectDiffirentTelesale
      )
      .test(
        "at-least-one-sale",
        "Cần chọn phân bổ cho telesale!",
        validateSelectTelesale
      )
      .test(
        "max-total-amount-telesale",
        "Tổng phân bổ telesale phải bằng 100%",
        validateMaxTotalAmountTelesale
      )
      .test(
        "max-total-amount-consultant",
        "Tổng phân bổ tư vấn viên và kĩ thuật viên phải bằng 100%",
        validateMaxTotalDiffTelesale
      )
      .test(
        "equals-source-revenue-sale-diffirent",
        "Tổng phân bổ telesale phải bằng các chức danh khác trong cùng nguồn!",
        validateEqualsSourceDiffirentTelesale
      )
      .nullable(),

    percentRevenue: Yup.number()
      .nullable()
      .min(0, "Tối thiểu 0%")
      .max(100, "Tối đa 100%"),
    ...(REQUIRED_CTKM
      ? {
        promotionProgram: Yup.object().nullable().required("Chưa chọn CTKM!"),
      }
      : {}),
  });
  const source = initialPatient?.patientInfo?.currentPatientSource;

  return (
    <PopupForm
      open={open}
      size="xl"
      handleClose={handleClose}
      title={`${initRegisterCard?.id ? "Chỉnh sửa" : "Thêm"}  thẻ`}
      formik={{
        initialValues: {
          // promotionProgram: defaultFreePromotion,
          ...initRegisterCard,
          department: initRegisterCard?.id
            ? initRegisterCard?.department
            : department,
          sourceRevenue: source,
          listCodeSource: listCodeSource,
        },
        validationSchema: validationSchema,
        onSubmit: async (values, actions) => {
          const data = await onSubmit(values, actions);
          if (handleAfterSubmit && data?.responseStatus !== false) {
            handleAfterSubmit();
          }
        },
        enableReinitialize: true,
      }}
      action={({ isSubmitting }) => {
        return (
          <div className="flex-center gap-1">
            <CommonButton
              type="submit"
              className="btn-primary"
              disabled={isSubmitting}
            >
              {!isMobile && <Save className="mr-2 " />}
              {`${initRegisterCard?.id ? "Chỉnh sửa" : "Thêm"}  thẻ`}
            </CommonButton>

            <CommonButton className="btn-gray" onClick={handleClose}>
              <Block className="mr-2" /> Đóng
            </CommonButton>
          </div>
        );
      }}
    >
      {({ setFieldValue, values }) => {
        return (
          <>
            <ValueForm
              listVatPercent={listVatPercent}
              patient={patient}
              customerSourceWalkIn={customerSourceWalkIn}
              handleGetListCodeSource={handleGetListCodeSource}
              initRegisterCard={initRegisterCard}
            />
            <DialogError
              patient={initialPatient?.patientInfo}
              setFieldValue={setFieldValue}
              values={values}
            />
          </>
        );
      }}
    </PopupForm>
  );
};

const ValueForm = observer(
  ({
    listVatPercent,
    patient,
    customerSourceWalkIn,
    handleGetListCodeSource,
    initRegisterCard,
  }) => {
    const { setFieldValue, values } = useFormikContext();
    let isPaymentPermission = isRoleHisPayment();
    let listFreeCode = getPromotionCodes();

    let currentConsultant = patient?.currentConsultant;
    let currentTelesale = patient?.currentTelesale;
    let totalAmountRevenues = 0;
    const isDisabled = [INVOICE_PAID, INVOICE_PARTIAL_PAID].includes(
      values?.paymentStatus
    );
    if (values?.priceWithTax) {
      totalAmountRevenues = +values?.totalAmount - (+values?.discount || 0);
    } else {
      totalAmountRevenues =
        +values?.totalAmount -
        (+values?.discount || 0) +
        (+values?.taxTotal || 0);
    }
    const handleChangeCard = (_, value) => {
      let feeItem =
        value?.clientCardFees?.length > 0
          ? getPriceTypeService(
            getIn(values, "patientTypeService"),
            value?.clientCardFees
          )
          : null;
      const price = feeItem?.price || value?.totalNetPrice;
      setFieldValue("priceWithTax", feeItem?.vatIncluded);
      setFieldValue("totalAmount", price * values?.quantity);
      setFieldValue("price", price);
      setFieldValue("patientTypeService", {
        ...feeItem?.patientTypeService,
        price: feeItem?.price,
      });

      let taxPercent = feeItem?.serviceVAT?.vatPercent?.toString() || 0;

      setFieldValue("taxPercent", taxPercent);
      let taxTotal;
      if (feeItem?.vatIncluded) {
        taxTotal =
          ((feeItem?.price * values?.quantity - values?.discount) /
            (+taxPercent + 100)) *
          +taxPercent;
      } else {
        taxTotal =
          (feeItem?.price * values?.quantity - values?.discount) *
          ((+taxPercent || 0) / 100);
      }

      setFieldValue("taxTotal", taxTotal);

      let revenueAllocations = value?.revenueAllocations;
      if (revenueAllocations) {
        let staffRevenues = revenueAllocations?.map((el) => ({
          position: el?.position,
          percentRevenue: el?.commissionRate,
          source: patient?.currentPatientSource
            ? patient?.currentPatientSource
            : customerSourceWalkIn,
          staff:
            currentConsultant?.position?.code === el?.position?.code
              ? currentConsultant
              : currentTelesale?.position?.code === el?.position?.code
                ? currentTelesale
                : null,
        }));

        setFieldValue("staffRevenues", staffRevenues);
      } else {
        setFieldValue("staffRevenues", []);
      }

      setFieldValue("clientCard", value);
      setFieldValue("name", value?.name);
      setFieldValue("allowUpdateUsedValue", value?.allowUpdateUsedValue);
      if (value?.totalPrice) {
        setFieldValue("totalValue", value?.totalPrice);
      } else if (value?.usedValueRate) {
        const totalValue =
          price * (values?.quantity || 1) * value?.usedValueRate;
        setFieldValue("totalValue", totalValue);
      } else {
        setFieldValue("totalValue", price * values?.quantity);
      }

      setFieldValue("cardUsers", [
        {
          patient: patient,
          userStatus: CARD_PATIENT_STATUS[0].value,
          isMainUser: true,
        },
      ]);
    };

    const handleChangePatientTypeService = (_, value) => {
      setFieldValue("patientTypeService", value);
      let vatPercent = +value?.serviceVAT?.vatPercent || 0;

      setFieldValue("price", value?.price);
      setFieldValue("priceWithTax", value?.vatIncluded);
      setFieldValue("taxPercent", vatPercent?.toString());

      let taxTotal;
      if (value?.vatIncluded) {
        taxTotal =
          ((value?.price * values?.quantity - values?.discount) /
            (vatPercent + 100)) *
          vatPercent;
      } else {
        taxTotal =
          (value?.price * values?.quantity - values?.discount) *
          ((vatPercent || 0) / 100);
      }
      setFieldValue("taxTotal", taxTotal);
    };

    const handleChangePrice = (e) => {
      let price = e.target.value;
      setFieldValue("price", price);
      let totalAmount = values?.quantity * price;
      setFieldValue("totalAmount", totalAmount);
      if (!values?.clientCard?.totalPrice) {
        const totalValue = totalAmount * values?.clientCard?.usedValueRate;
        setFieldValue("totalValue", totalValue);
      }

      let discount = values?.discount;
      if (values?.percentDiscount) {
        discount = (totalAmount * values?.percentDiscount) / 100;
        setFieldValue("discount", discount);
      }

      let taxTotal;
      if (values?.priceWithTax) {
        taxTotal =
          ((totalAmount - discount) / (+values?.taxPercent + 100)) *
          +values?.taxPercent;
      } else {
        taxTotal =
          (totalAmount - discount) * ((+values?.taxPercent || 0) / 100);
      }

      setFieldValue("taxTotal", taxTotal);
    };

    const handleChangeTotalAmount = (e) => {
      let totalAmount = e.target.value;
      setFieldValue("totalAmount", totalAmount);
      let discount = values?.discount;
      if (values?.percentDiscount) {
        discount = (totalAmount * values?.percentDiscount) / 100;
        setFieldValue("discount", discount);
      }
      let taxTotal;
      if (values?.priceWithTax) {
        taxTotal =
          ((totalAmount - discount) / (+values?.taxPercent + 100)) *
          +values?.taxPercent;
      } else {
        taxTotal =
          (totalAmount - discount) * ((+values?.taxPercent || 0) / 100);
      }

      setFieldValue("taxTotal", taxTotal);
    };
    const [checkedState, setCheckedState] = useState(false);
    // Có dữ liệu cấn trừ hay không
    const hasData =
      (values?.voucherAllocations?.length || 0) > 0 ||
      (values?.invoiceItemAllocations?.length || 0) > 0;
    // Đang chỉnh sửa
    const isEdit = Boolean(initRegisterCard?.id);
    // Checkbox hiển thị
    const checked = checkedState || hasData;
    // Disable CHỈ khi edit
    const disabled = isEdit && hasData;
    return (
      <>
        {/* <FormikFocusError /> */}
        <Grid container spacing={1}>
          <Grid item xs={12} md={values?.clientCard ? 9 : 9}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <SourceRegister
                  disabled={isDisabled}
                  handleGetListCodeSource={handleGetListCodeSource}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={3}>
                <GlobitsDateTimePicker
                  name={"startDate"}
                  label="Ngày đăng ký"
                  maxDateMessage="Ngày đăng ký phải trước ngày hiện tại"
                  maxDate={new Date()}
                  isDateTimePicker
                  disabled={isDisabled}
                  onChange={(value) => {
                    setFieldValue("startDate", value);
                    if (!value) return;

                    const searchCodeSource = {
                      level: LEAD_SOURCE_LEVEL.LEVEL_2.value,
                      startDate: value,
                      patientId: values?.patient?.id,
                      voucherIds: Array.isArray(values?.voucherAllocations)
                        ? values.voucherAllocations
                          .map((item) => item?.voucher?.id)
                          .filter(Boolean)
                        : [],

                      invoiceItemIds: Array.isArray(
                        values?.invoiceItemAllocations
                      )
                        ? values.invoiceItemAllocations
                          .map((item) => item?.invoiceItem?.id)
                          .filter(Boolean)
                        : [],
                    };

                    handleGetListCodeSource(searchCodeSource, setFieldValue);
                  }}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={3}>
                <GlobitsDateTimePicker
                  name={"endDate"}
                  label="Ngày hết hạn sử dụng"
                  isDateTimePicker
                  disabled={isDisabled}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={3}>
                <GlobitsPagingAutocomplete
                  api={pagingClientCard}
                  name={"clientCard"}
                  label="Thẻ khách hàng"
                  searchObject={{
                    type: TYPE_CARD[0].value,
                    isUsing: true,
                    isApply: true,
                  }}
                  onChange={handleChangeCard}
                  disabled={isDisabled}
                  filterOptions={filterBaseOptions}
                  ListboxComponent={forwardRef((props, ref) => {
                    const { children, ...other } = props;
                    return (
                      <ul {...other} ref={ref}>
                        <ol>
                          <li>{children}</li>
                        </ol>
                      </ul>
                    );
                  })}
                  renderOption={(option) => renderOptionsderOptionsCard(option)}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <GlobitsTextField
                  name={"name"}
                  label="Tên thẻ đăng ký"
                // disabled={isDisabled}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={2}>
                <GlobitsNumberInput
                  label={"Số lượng"}
                  name={"quantity"}
                  disabled={isDisabled}
                  onChange={(e) => {
                    let quantity = e.target.value;
                    setFieldValue("quantity", quantity);
                    setFieldValue("totalAmount", quantity * values?.price);

                    // Clear CTKM khi thay đổi số lượng
                    if (values?.promotionProgram) {
                      setFieldValue("promotionProgram", null);
                      setFieldValue("discount", 0);
                      setFieldValue("percentDiscount", 0);
                    }
                  }}
                />
              </Grid>

              <Grid item xs={6} sm={6} md={4}>
                <GlobitsAutocomplete
                  label={"Loại giá"}
                  disabled={isDisabled}
                  options={values?.clientCard?.clientCardFees?.map((item) => ({
                    ...item?.patientTypeService,
                    price: item?.price,
                    vatIncluded: item?.vatIncluded,
                    serviceVAT: item?.serviceVAT,
                  }))}
                  onChange={handleChangePatientTypeService}
                  name={"patientTypeService"}
                  getOptionLabel={(option) => {
                    return option?.name
                      ? `${option.name}${option?.price ? `: ${formatMoney(option.price)}` : ""
                      }`
                      : "";
                  }}
                />
              </Grid>

              <Grid item xs={6} sm={6} md={2}>
                <GlobitsVNDCurrencyInput
                  label={"Đơn giá"}
                  disabled={
                    (PERMISSION_ROLE_HIS_PAYMENT &&
                      !isPaymentPermission &&
                      !(values?.clientCard?.usedValueRate > 0)) ||
                    isDisabled
                  }
                  name={"price"}
                  onChange={handleChangePrice}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={2}>
                <GlobitsVNDCurrencyInput
                  label={"Thành tiền"}
                  disabled
                  name={"totalAmount"}
                  onChange={handleChangeTotalAmount}
                />
              </Grid>

              <Grid item xs={6} sm={6} md={2}>
                <GlobitsVNDCurrencyInput
                  label={"Giá trị sử dụng"}
                  disabled={!values?.allowUpdateUsedValue}
                  name={"totalValue"}
                // onChange={handleChangeTotalAmount}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={3}>
                <GlobitsPagingAutocomplete
                  api={pagingProgram}
                  searchObject={{
                    codes: listFreeCode,
                    productCode: values?.clientCard?.code,
                    isPaying: false,
                  }}
                  label={"Chương trình khuyến mãi"}
                  name={`promotionProgram`}
                  disabled={isDisabled}
                  getOptionDisabled={(option) => {
                    // Lấy giá trị hiện tại: đơn giá * số lượng - tiền khấu trừ (nếu có)
                    const currentAmount =
                      (values?.price || 0) * (values?.quantity || 1) -
                      (values?.oldCredit || values?.oldTreatmentCredit || 0);
                    // Disable option nếu giá trị đơn hàng tối thiểu < 0 và thành tiền >= giá trị đơn hàng tối thiểu
                    if (
                      option?.minInvoiceAmount > 0 &&
                      currentAmount < option?.minInvoiceAmount
                    ) {
                      return true;
                    }
                    return false;
                  }}
                  onChange={(_, value) => {
                    // console.log("value", value);

                    setFieldValue(`promotionProgram`, value);
                    if (!value) {
                      // Tính lại thành tiền khi bỏ chọn CTKM
                      const price = values?.price || 0;
                      const quantity = values?.quantity || 1;
                      const newTotalAmount = price * quantity;

                      setFieldValue("discount", 0);
                      setFieldValue("percentDiscount", 0);
                      setFieldValue("totalAmount", newTotalAmount);
                    }
                  }}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={2}>
                <GlobitsNumberInput
                  label={"% giảm giá"}
                  disabled={
                    isDisabled ||
                    (REQUIRED_CTKM_DISCOUNT && !values?.promotionProgram)
                  }
                  name={"percentDiscount"}
                  onChange={(e) => {
                    let percentDiscount = +e?.target.value;
                    setFieldValue("percentDiscount", percentDiscount);
                    setFieldValue(
                      "discount",
                      (values?.price * values?.quantity * percentDiscount) / 100
                    );
                  }}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={2}>
                <GlobitsVNDCurrencyInputOnlyChange
                  isOnlyOnChange
                  label={"Số tiền giảm"}
                  disabled={
                    isDisabled ||
                    (REQUIRED_CTKM_DISCOUNT && !values?.promotionProgram)
                  }
                  name={"discount"}
                  onChange={(e) => {
                    let discount = +e?.target.value;
                    setFieldValue("discount", discount);
                    const totalAmount = values?.price;

                    let percentDiscount = (discount / totalAmount) * 100;
                    setFieldValue("percentDiscount", percentDiscount);

                    let taxTotal;
                    if (values?.priceWithTax) {
                      taxTotal =
                        ((values?.price * values?.quantity - discount) /
                          (+values?.taxPercent + 100)) *
                        +values?.taxPercent;
                    } else {
                      taxTotal =
                        (values?.price * values?.quantity - discount) *
                        ((+values?.taxPercent || 0) / 100);
                    }

                    setFieldValue("taxTotal", taxTotal);
                  }}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={2}>
                <GlobitsAutocompleteTextAndSelect
                  options={listVatPercent || []}
                  label={"% Vat"}
                  disabled={values?.priceWithTax || isDisabled}
                  name={"taxPercent"}
                  value={values?.taxPercent}
                  onInputChange={(newValue) => {
                    setFieldValue("taxPercent", newValue?.toString());
                    let taxTotal;
                    if (values?.priceWithTax) {
                      taxTotal =
                        ((values?.price * values?.quantity - values?.discount) /
                          (+newValue + 100)) *
                        +newValue;
                    } else {
                      taxTotal =
                        (values?.price * values?.quantity - values?.discount) *
                        (+newValue / 100);
                    }

                    setFieldValue("taxTotal", taxTotal);
                  }}
                  displayLabel={"vatPercent"}
                  onChange={(value) => {
                    setFieldValue("taxPercent", value?.vatPercent?.toString());
                    let taxTotal;

                    if (values?.priceWithTax) {
                      taxTotal =
                        ((values?.price * values?.quantity - values?.discount) /
                          (+value?.vatPercent + 100)) *
                        +value?.vatPercent;
                    } else {
                      taxTotal =
                        (values?.price * values?.quantity - values?.discount) *
                        ((+value?.vatPercent || 0) / 100);
                    }

                    setFieldValue("taxTotal", taxTotal);
                  }}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={2}>
                <GlobitsVNDCurrencyInput
                  label={"Tiền Vat"}
                  name={`taxTotal`}
                  disabled
                />
              </Grid>
              <Grid item xs={6} sm={6} md={2}>
                <GlobitsVNDCurrencyInput
                  label="Số dư"
                  name={`retainedAmount`}
                  disabled
                />
              </Grid>
              <Grid item xs={6} sm={6} md={2} container alignItems="center">
                <GlobitsCheckBox
                  label={"Giá kèm thuế"}
                  name={"priceWithTax"}
                  disabled
                />
              </Grid>
              <Grid item xs={6} sm={6} md={2} container alignItems="center">
                <GlobitsCheckBox
                  label={"Cho phép cập nhật giá trị sd"}
                  name={"allowUpdateUsedValue"}
                  disabled
                />
              </Grid>

              <Grid item xs={6} sm={6} md={3} container alignItems="center">
                <GlobitsCheckBox
                  label="Cấn trừ từ đơn hàng/tiền cọc"
                  checked={checked}
                  disabled={disabled}
                  onChange={(e) => {
                    const value = e.target.checked;
                    setCheckedState(value);
                    if (!value && !isEdit) {
                      setFieldValue("voucherAllocations", []);
                      setFieldValue("invoiceItemAllocations", []);
                    }
                  }}
                />
              </Grid>
              {/* <Grid item xs={6} sm={6} md={2}>
                <GlobitsTextField
                  label={"Mã giảm giá"}
                  name={"marketingVoucherCode"}
                  disabled={isDisabled}
                />
              </Grid> */}

              <Grid item xs={12} sm={6} md={3}>
                <GlobitsTextField label={"Ghi chú"} name={"note"} isTextArea />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={3}>
            <Grid container direction="column" spacing={1}>
              <Grid item>
                <RowTotalCard data={values} />
              </Grid>

              {values?.clientCard && (
                <Grid item>
                  <CreditCard card={values?.clientCard} values={values} />
                </Grid>
              )}
            </Grid>
          </Grid>
          {checked && (
            <Grid item xs={12} md={12}>
              <DeductionList initRegisterTreatmentPlan={initRegisterCard} />
            </Grid>
          )}

          <Grid item xs={12} md={12}>
            <Grid container spacing={1}>
              {/* Phân bổ doanh thu */}
              <RegisterServiceStaffsRevenue
                totalAmount={totalAmountRevenues}
                popupType={POPUP_TYPE_CARD}
              />
            </Grid>
          </Grid>

          {values?.clientCard && (
            <Grid item xs={12} md={6}>
              <Grid container spacing={1}>
                <CardUser values={values} setFieldValue={setFieldValue} />
              </Grid>
            </Grid>
          )}
        </Grid>
      </>
    );
  }
);

const renderOptionsderOptionsCard = (option) => {
  return (
    <div
      style={{
        gap: "16px",
        alignItems: "flex-start",
      }}
    >
      <div
        style={{
          minWidth: "100px",
          fontWeight: "bold",
          fontSize: "14px",
          color: "#000",
          wordBreak: "break-word",
        }}
      >
        {option?.name}
      </div>
      <div
        style={{
          flex: 1,
          display: "flex",
          flexWrap: "wrap",
          gap: "6px",
        }}
      >
        {option?.clientCardFees?.map((el, ind) => (
          <div
            key={ind}
            style={{
              fontSize: "10px",
              borderRadius: "6px",
              whiteSpace: "nowrap",
              backgroundColor: ind % 2 === 1 ? "#f1632159" : "#a8e1a8",
              padding: "2px",
              color: "#000",
            }}
          >
            {el?.patientTypeService?.name}:{" "}
            <strong>{el?.price?.toLocaleString("vi-VN") || 0}</strong>
          </div>
        ))}
      </div>
    </div>
  );
};

const CreditCard = ({ card, values }) => {
  const [qr, setQr] = useState(null);

  useEffect(() => {
    const fetchQrCode = async () => {
      try {
        const qrCode = await handleGetQRCodeByValue(card?.code);
        setQr(qrCode);
      } catch (error) {
        console.error("Failed to fetch QR code:", error);
      }
    };

    if (card?.id) {
      fetchQrCode();
    }
  }, [card?.id]);

  return (
    <article class="payment-card" style={{ backgroundColor: "#422369" }}>
      <img
        src="https://sondnpt00343.github.io/f8-project-08/assets/img/card/plane-bg.svg"
        alt=""
        class="payment-card__img"
      />
      <div class="payment-card__top flex-end">
        <img
          src="
        https://thammylinhanh.vn/wp-content/uploads/2024/11/logo-Tham-my-Quoc-te-Linh-Anh.jpg
        "
          alt=""
          className="payment-card__logo"
        />
      </div>
      <div class="payment-card__number">
        <div>{card?.code}</div>
        <span class="payment-card__name">{card?.name}</span>
      </div>
      <div class="payment-card__bottom justify-between align-center">
        <div>
          <p class="payment-card__label">Giá trị</p>
          <p class="payment-card__value">
            {formatMoney(+values?.totalValue || 0)}
          </p>
        </div>

        {/* <div class="payment-card__circle"></div> */}
        <div className="payment-card__gift">
          <img src={qr} alt="" />
        </div>
      </div>
    </article>
  );
};

const DialogError = observer(({ patient, setFieldValue, values }) => {
  const { openConfirmMessage, handleCloseConfirmMessage } =
    useStore().patientManagementStore.registerCardStore;
  return (
    <>
      {!!openConfirmMessage && (
        <ConfirmPopup
          open={!!openConfirmMessage}
          onClose={() => {
            handleCloseConfirmMessage(null);

            if (!values?.id) {
              // khi đóng popup thì reset lại ngày đăng kí
              setFieldValue("startDate", new Date());
            }
          }}
          text={openConfirmMessage}
          onConfirm={() => {
            const url =
              Config.ROOT_PATH +
              PathModule.PATIENT_MANAGEMENT +
              `/patient-general?patientId=${patient?.id}`;

            window.open(url, "_blank");
          }}
          textConfirm={"Thông tin khách"}
          textClose={"Quay lại"}
          title="Đăng ký thất bại"
          isNotAPromise
        />
      )}
    </>
  );
});

export const CardUser = ({ values, setFieldValue }) => {
  return (
    <FieldArray name="cardUsers">
      {({ remove, push }) => (
        <>
          <Grid item xs={12} sm={6} md={5}>
            <GlobitsPagingAutocomplete
              label={"Chọn khách hàng dùng thẻ"}
              disableClearable
              api={pagingPatient}
              name={`patient`}
              // displayLabel="staffName"
              displayLabel={"displayName"}
              autoUpercase
              onChange={(_, value, reason, option) => {
                let item = {
                  patient: value,
                  userStatus: CARD_PATIENT_STATUS[0].value,
                };
                if (values?.cardUsers && values?.cardUsers?.length === 0) {
                  item.isMainUser = true;
                }
                push(item);
                if (reason === "remove-option") {
                  return;
                }
              }}
              renderTags={() => ""}
              value={values?.patient || []}
              getOptionLabel={(option) => {
                if (!option) return "";
                const code = option?.code || "";
                const name = option?.displayName || "";
                return `${name} - ${code}`;
              }}
              getOptionDisabled={(option) => {
                const selectedCardUsers = getIn(values, "cardUsers");
                if (
                  selectedCardUsers?.find(
                    (it) => it?.patient?.id === option?.id
                  )
                ) {
                  return true;
                }
                return false;
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <div className="table-root mt-2" style={{ width: "100%" }}>
              <table className="table-container" style={{ minWidth: "560px" }}>
                <thead>
                  <tr className="row-table-header">
                    <th width="5%">STT</th>
                    <th width="50%">Khách hàng</th>
                    <th width="25%">Trạng thái</th>
                    <th width="10%">Là người dùng chính</th>
                    <th>Thao tác</th>
                  </tr>
                </thead>
                <tbody>
                  {values?.cardUsers?.length > 0 &&
                    values?.cardUsers?.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td align="center">{index + 1}</td>
                          <td>
                            <GlobitsPagingAutocomplete
                              api={pagingPatient}
                              name={`cardUsers[${index}].patient`}
                              displayLabel={"displayName"}
                              getOptionLabel={(option) => {
                                if (!option) return "";
                                const code = option?.code || "";
                                const name = option?.displayName || "";
                                return `${name} - ${code}`;
                              }}
                              autoUpercase
                            />
                          </td>

                          <td>
                            <GlobitsSelectInput
                              options={CARD_PATIENT_STATUS}
                              name={`cardUsers[${index}].userStatus`}
                            />
                          </td>
                          <td>
                            <GlobitsCheckBox
                              name={`cardUsers[${index}].isMainUser`}
                              alignPosition="center"
                              onChange={(e) => {
                                let newData =
                                  values?.cardUsers &&
                                  values?.cardUsers?.map((el, ind) => {
                                    if (index === ind)
                                      return {
                                        ...el,
                                        isMainUser: true,
                                      };
                                    else
                                      return {
                                        ...el,
                                        isMainUser: false,
                                      };
                                  });
                                setFieldValue("cardUsers", newData);
                              }}
                            />
                          </td>
                          <td align="center">
                            <span
                              tooltip={"Xóa"}
                              className="pointer tooltip"
                              onClick={() => remove(index)}
                            >
                              <IconDelete />
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </Grid>
        </>
      )}
    </FieldArray>
  );
};
export default memo(RegisterCardPopup);
